import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Roles } from 'src/types/User';
import { GetUserOrganizationsDto } from 'woofwoof-api';

// ----------------------------------------------------------------------

interface OrganizationState {
  selectedOrganization: (GetUserOrganizationsDto & { role: Roles }) | null;
}

const initialState: OrganizationState = {
  selectedOrganization: null,
};

const slice = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    setSelectedOrganization(
      state,
      action: PayloadAction<{
        organization: GetUserOrganizationsDto;
        role: Roles;
      }>,
    ) {
      const { organization, role } = action.payload;

      // Set the selected organization and role
      state.selectedOrganization = { ...organization, role };
    },

    clearSelectedOrganization(state) {
      state.selectedOrganization = null;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { setSelectedOrganization, clearSelectedOrganization } =
  slice.actions;
